module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/people_b-0e735d721f4e3492dc568e29611c8aea.svg";